import React, { useState, useEffect, useContext, Component } from 'react';
import { useNavigate,Link ,useParams} from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { authActions } from '../../redux/store';
import { toast } from 'react-hot-toast';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Error from '../assets_user/img/error.jpg'
import HeaderHome from '../components/HeaderHome';
import getDecryptData from '../../helper/getDecryptData';
import { adminurl } from '../../axiosInstance';
import axiosInstance from '../../axiosInstance';
import LoadingScreen from '../components/LoadingScreen';



const HomeMain = () => {
const { slug } = useParams();
          const decryptdatajson = getDecryptData();

  const navigate = useNavigate();

    const [isLoading, setloading] = useState(true);
  
      const [Data, setData] = useState([]);



    const getHome = async () => {
   
      setloading(true);
      try {
        const { data } = await axiosInstance.get(`/all-home-category?cid=${slug ?? ''}&home=true`);
     
        setData(data.categories || []);
        // Delay the execution of buildScript by 1 secon
        console.log('datadata',data);
       }
      catch (error) {
        console.log(error);
        // toast.error("Error fetching Single Blog!");
      } finally {
        setloading(false);
      }
  
  
    };
  
  
  
  
    useEffect(() => {
      getHome();
      window.scrollTo(0, 0);
    }, [slug]);
  
  const clickhome = async (data) =>{

        const id = decryptdatajson?._id;

      if(data === 'userPartner'){
       if(id){
  navigate(`/login`)
 }else{
    navigate(`/user-patner`)
 }
      }
      if(data === 'farmerPartner'){
          
      navigate('/shop-cart');

      }

       if(data === 'sellerPartner'){
 if(id){
  navigate(`/seller/${id}`)
 }else{
    navigate(`/home`)
 }
      }

      if(data === 'adminPartner'){
       window.location.assign(`${adminurl}profile/edit`)
      }

  }


    return (
        <>
 <div className='app-box'>
 <div className="container-lg py-4">
   <HeaderHome/>
   <div style={{minHeight:'90vh'}} >
  
 <div className="row g-4 mt-2 align-items-start" >

{!isLoading ?  <> 
{slug && 
  <div className='col-12'>
      {/* <span className='mx-2'> Business Patner</span> */}

  <Link className='btn btn-dark btn-sm' to={'/home'}>
  <i className="ri-arrow-left-s-line" />  Go Back
  </Link>
 </div>
}
 
 

{Data.map((mydata,index) => (
    <div className="col-6 col-md-6 col-lg-6 h-auto" key={index}>
    <Link type="button" 
    to={`${mydata.auth === 1 ? (mydata.authLink.includes('{{id}}') ? (
        decryptdatajson?._id ?  mydata.authLink.replace('{{id}}', decryptdatajson?._id ) : '/home'
      )
      : mydata.authLink)
         :  mydata.link}`}  
     className="text-decoration-none text-reset border-0 h-100 w-100">
      <div className="card rounded-4 shadow-lg h-100">
        <div className="card-body text-center">
          <div className="  w-25 bg-white mx-auto d-flex align-items-center justify-content-center rounded-3 mb-2">
            <i className={mydata.icon_image} />
          </div>
          
          <h6 className="fw-bold mb-1 small">{mydata.title}</h6>
          <div className="small text-muted">
            {mydata.para} 
          </div>
        </div>
      </div>
    </Link>
  </div>
))}
</> : <LoadingScreen/>}

<div className='d-none'>

  {slug === "user" ? 
  <>
 <div className='col-12'>
  <span className='mx-2'> User Patner</span>
  <Link className='btn btn-dark btn-sm' to={'/'}>
  <i className="ri-arrow-left-s-line" />  Go Back
  </Link>
 </div>
  {/* Farmer Partner */}
  <div className="col-6 col-md-6 col-lg-4">
    <button type="button" onClick={()=>{clickhome('farmerPartner')}}  className="text-decoration-none text-reset border-0 h-100 w-100">
      <div className="card rounded-4 shadow-lg h-100">
        <div className="card-body text-center">
          <div className="  w-25 bg-white mx-auto d-flex align-items-center justify-content-center rounded-3 mb-2">
            <i className="bi bi-tree display-5" />
          </div>
          <h6 className="fw-bold mb-1 small">Farmer Partner</h6>
          <div className="small text-muted">Register farm &amp; supply</div>
        </div>
      </div>
    </button>
  </div>
  {/* Seller Partner */}
  <div className="col-6 col-md-6 col-lg-4">
    <button type="button" onClick ={()=>{clickhome('sellerPartner')}} className="text-decoration-none text-reset border-0 h-100 w-100">
      <div className="card rounded-4 shadow-lg h-100">
        <div className="card-body text-center">
          <div className="  w-25 bg-white mx-auto d-flex align-items-center justify-content-center rounded-3 mb-2">
            <i className="bi bi-bag-check display-5" />
          </div>
          <h6 className="fw-bold mb-1 small">Seller Partner</h6>
          <div className="small text-muted">List products for sale</div>
        </div>
      </div>
    </button>
  </div>
  {/* Wearhouse Partner */}
  <div className="col-6 col-md-6 col-lg-4">
    <button type="button"  onClick ={()=>{clickhome('adminPartner')}} className="text-decoration-none text-reset border-0 h-100 w-100">
      <div className="card rounded-4 shadow-lg h-100">
        <div className="card-body text-center">
          <div className="  w-25 bg-white mx-auto d-flex align-items-center justify-content-center rounded-3 mb-2">
            <i className="bi bi-box-seam display-5" />
          </div>
          <h6 className="fw-bold mb-1 small">Wearhouse Partner</h6>
          <div className="small text-muted">Manage storage availability</div>
        </div>
      </div>
    </button>
  </div>
  {/* Yard Store Partner */}
  <div className="col-6 col-md-6 col-lg-4">
    <button type="button"  onClick ={()=>{clickhome('adminPartner')}} className="text-decoration-none text-reset border-0 h-100 w-100">
      <div className="card rounded-4 shadow-lg h-100">
        <div className="card-body text-center">
          <div className="  w-25 bg-white mx-auto d-flex align-items-center justify-content-center rounded-3 mb-2">
            <i className="bi bi-shop-window display-5" />
          </div>
          <h6 className="fw-bold mb-1 small">Yard Store Partner</h6>
          <div className="small text-muted">Add yard/store inventory</div>
        </div>
      </div>
    </button>
  </div>
  {/* Retailer Shop */}
  <div className="col-6 col-md-6 col-lg-4">
    <button type="button"  onClick={()=>{clickhome('adminPartner')}} className="text-decoration-none text-reset border-0 h-100 w-100">
      <div className="card rounded-4 shadow-lg h-100">
        <div className="card-body text-center">
          <div className="  w-25 bg-white mx-auto d-flex align-items-center justify-content-center rounded-3 mb-2">
            <i className="bi bi-shop display-5" />
          </div>
          <h6 className="fw-bold mb-1 small">Retailer Shop</h6>
          <div className="small text-muted">Register retail outlet</div>
        </div>
      </div>
    </button>
  </div>
  {/* Whole Seller */}
  <div className="col-6 col-md-6 col-lg-4">
   <button type="button"  onClick={()=>{clickhome('adminPartner')}} className="text-decoration-none text-reset border-0 h-100 w-100">
      <div className="card rounded-4 shadow-lg h-100">
        <div className="card-body text-center">
          <div className="  w-25 bg-white mx-auto d-flex align-items-center justify-content-center rounded-3 mb-2">
            <i className="bi bi-cart-check display-5" />
          </div>
          <h6 className="fw-bold mb-1 small">Whole Seller</h6>
          <div className="small text-muted">Bulk purchase &amp; pricing</div>
        </div>
      </div>
    </button>
  </div>
  {/* Company */}
  <div className="col-6 col-md-6 col-lg-4">
    <button type="button"   onClick={()=>{clickhome('adminPartner')}} className="text-decoration-none text-reset border-0 h-100 w-100">
      <div className="card rounded-4 shadow-lg h-100">
        <div className="card-body text-center">
          <div className="  w-25 bg-white mx-auto d-flex align-items-center justify-content-center rounded-3 mb-2">
            <i className="bi bi-buildings display-5" />
          </div>
          <h6 className="fw-bold mb-1 small">Company</h6>
          <div className="small text-muted">Corporate onboarding</div>
        </div>
      </div>
    </button>
  </div>
  {/* Delivery Partner Service */}
  <div className="col-6 col-md-6 col-lg-4">
    <button type="button"  onClick={()=>{clickhome('adminPartner')}} className="text-decoration-none text-reset border-0 h-100 w-100">
      <div className="card rounded-4 shadow-lg h-100">
        <div className="card-body text-center">
          <div className="  w-25 bg-white mx-auto d-flex align-items-center justify-content-center rounded-3 mb-2">
            <i className="bi bi-truck display-5" />
          </div>
          <h6 className="fw-bold mb-1 small">Delivery Partner Service</h6>
          <div className="small text-muted">Join as delivery partner</div>
        </div>
      </div>
    </button>
  </div>
  </> :  slug === "business" ? <>

   <div className='col-12'>
      <span className='mx-2'> Business Patner</span>

  <Link className='btn btn-dark btn-sm' to={'/'}>
  <i className="ri-arrow-left-s-line" />  Go Back
  </Link>
 </div>
  {/* Business Partners */}
{[
  { name: "Fund Partner", icon: "bi bi-cash-stack", key: "fundPartner" },
  { name: "Channel Partner", icon: "bi bi-share", key: "channelPartner" },
  { name: "Employee Partner", icon: "bi bi-person-badge", key: "employeePartner" },
  { name: "Company Partner", icon: "bi bi-building", key: "companyPartner" },
  { name: "Trainer Partner", icon: "bi bi-easel", key: "trainerPartner" },
  { name: "CA Partner", icon: "bi bi-calculator", key: "caPartner" },
  { name: "Lawyer Partner", icon: "ri-user-2-fill", key: "lawyerPartner" },
  { name: "Sales Partner", icon: "bi bi-graph-up", key: "salesPartner" },
  { name: "Management Partner", icon: "bi bi-people", key: "managementPartner" },
].map((partner) => (
  <div className="col-6 col-md-6 col-lg-4 mb-4" key={partner.key}>
    <button
      type="button"
      onClick={() => clickhome(partner.key)}
      className="text-decoration-none text-reset border-0 h-100 w-100"
    >
      <div className="card rounded-4 shadow-lg h-100">
        <div className="card-body text-center">
          <div className="w-25 bg-white mx-auto d-flex align-items-center justify-content-center rounded-3 mb-2">
            <i className={`${partner.icon} display-5`} />
          </div>
          <h6 className="fw-bold mb-1 small">{partner.name}</h6>
          <div className="small text-muted">Join as {partner.name.toLowerCase()}</div>
        </div>
      </div>
    </button>
  </div>
))}

 </>
: <>
</>  }

  {!slug  && 
  <> 
 {/* User Partner */}
  <div className="col-6 col-md-6 col-lg-6 h-auto">
    <Link type="button" to={'/home/user'}   className="text-decoration-none text-reset border-0 h-100 w-100">
      <div className="card rounded-4 shadow-lg h-100">
        <div className="card-body text-center">
          <div className="  w-25 bg-white mx-auto d-flex align-items-center justify-content-center rounded-3 mb-2">
            <i className="bi bi-person-badge display-5" />
          </div>
          <h6 className="fw-bold mb-1 small">User Partner</h6>
          <div className="small text-muted">
            Create account &amp; manage profile
          </div>
        </div>
      </div>
    </Link>
  </div>

   {/* User Partner */}
  <div className="col-6 col-md-6 col-lg-6 h-auto">
    <Link type="button" to={'/home/business'}   className="text-decoration-none text-reset border-0 h-100 w-100">
      <div className="card rounded-4 shadow-lg h-100">
        <div className="card-body text-center">
          <div className="  w-25 bg-white mx-auto d-flex align-items-center justify-content-center rounded-3 mb-2">
            <i className="ri-group-3-fill display-5" />  
          </div>
          <h6 className="fw-bold mb-1 small">Bussiness Partner</h6>
          <div className="small text-muted">
            Create account &amp; manage profile
          </div>
        </div>
      </div>
    </Link>
  </div>

    </>
}
  
</div>

</div>
  
   </div>


</div>
 </div>
   


 
        </>

    );
};

export default HomeMain